import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { KEYWORD_GROUPS, PAGE_KEYWORDS } from "../data/keywords";

const setMeta = (name, content) => {
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) { el = document.createElement("meta"); el.setAttribute("name", name); document.head.appendChild(el); }
  el.setAttribute("content", content);
};

export const usePageMeta = (title, description) => {
  const { pathname } = useLocation();
  useEffect(() => {
    document.title = title;
    setMeta("description", description);
    const titles = PAGE_KEYWORDS[pathname] || [];
    const words = KEYWORD_GROUPS.filter((g) => titles.includes(g.title)).flatMap((g) => g.items);
    if (words.length) setMeta("keywords", words.join(", "));
  }, [title, description, pathname]);
};
